export type BreadcrumbJsonLdItem = {
  name: string
  url: string
}

export const buildBreadcrumbListJsonLd = (items: BreadcrumbJsonLdItem[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
})
